<div class="content-wrapper">
  <div class="card case-view-card">
    <div class="card-header bg-primary">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <h4 class="title mb-0">3BC CHAMBERS BARRISTER DIARY</h4>
        </div>
        <div class="d-flex align-items-center position-relative">
          <button class="btn btn-outline-secondary btn-sm mr-3" (click)="toggleFilters()" [title]="filtersExpanded ? 'Hide Filters' : 'Show Filters'">
            <i class="icon-settings"></i> Filters
          </button>
          <div class="filters-dropdown" *ngIf="filtersExpanded">
            <div class="filters-content">
              <div class="form-group">
                <label for="entryType">Entry Type</label>
                <select name="entryType" id="entryType" class="form-control form-control-sm" [(ngModel)]="diaryFilter.entryType" (change)="loadEvents()">
                  <option value="all">All Types</option>
                  <option value="0">New Cases</option>
                  <option value="1">Duplicate Cases</option>
                </select>
              </div>

              <div class="form-group">
                <label for="caseTypeId">Case Type</label>
                <select name="caseTypeId" id="caseTypeId" class="form-control form-control-sm" [(ngModel)]="diaryFilter.caseTypeId" (change)="loadEvents()">
                  <option value="all">All Types</option>
                  <option *ngFor="let casetype of caseTypes" value="{{casetype.id}}">{{casetype.name}}</option>
                </select>
              </div>

              <div class="form-group">
                <label for="clientTypeId">Client Type</label>
                <select name="clientTypeId" id="clientTypeId" class="form-control form-control-sm" [(ngModel)]="diaryFilter.clientTypeId" (change)="loadEvents()">
                  <option value="all">All Type</option>
                  <option value="Solicitor">Solicitor</option>
                  <option value="1">Direct Public Access</option>
                </select>
              </div>

              <div class="form-group">
                <label for="courtId">Court</label>
                <select name="courtId" id="courtId" class="form-control form-control-sm" [(ngModel)]="diaryFilter.courtId" (change)="loadEvents()">
                  <option value="all">All Courts</option>
                  <option *ngFor="let court of courts" value="{{court.id}}">{{court.courtName}}</option>
                </select>
              </div>

              <div class="form-group">
                <label for="fundingTypeId">Funding Type</label>
                <select name="fundingTypeId" id="fundingTypeId" class="form-control form-control-sm" [(ngModel)]="diaryFilter.fundingTypeId" (change)="loadEvents()">
                  <option value="all">All Types</option>
                  <option *ngFor="let fundingType of fundingTypes" value="{{fundingType.id}}">{{fundingType.name}}</option>
                </select>
              </div>

              <div class="form-group">
                <label for="courtBundleReceived">Court Bundle Received</label>
                <select name="courtBundleReceived" id="courtBundleReceived" class="form-control form-control-sm" [(ngModel)]="diaryFilter.courtBundleReceived" (change)="loadEvents()">
                  <option value="all">All</option>
                  <option value="Yes- By Eamil">Yes - By Email</option>
                  <option value="Yes - By Post">Yes - By Post</option>
                  <option value="Yes - By Courier">Yes - By Courier</option>
                  <option value="No">No</option>
                </select>
              </div>

              <div class="form-group">
                <label for="attendanceNoteReceived">Attendance Note Received</label>
                <select name="attendanceNoteReceived" id="attendanceNoteReceived" class="form-control form-control-sm" [(ngModel)]="diaryFilter.attendanceNoteReceived" (change)="loadEvents()">
                  <option value="all">All</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                  <option value="Not Required">Not Required</option>
                </select>
              </div>

              <div class="form-group">
                <label for="paymentReceived">Payment Received</label>
                <select name="paymentReceived" id="paymentReceived" class="form-control form-control-sm" [(ngModel)]="diaryFilter.paymentReceived" (change)="loadEvents()">
                  <option value="all">All</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                  <option value="Deferred">Deferred</option>
                </select>
              </div>

              <button class="btn btn-primary btn-block" (click)="clearFilters()">Clear Filters</button>
            </div>
          </div>
          <span class="date-label mr-3">Go To Date :</span>
          <input type="date" name="calenderDate" id="calenderDate" class="form-control form-control-sm date-picker" placeholder="Select Goto Date" (change)="setCalenderDate($event)">
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="diary-layout">
        <!-- Main Calendar Area -->
        <div class="calendar-area">
          <div class="calendar-container">
            <full-calendar [options]="calendarOptions" #calendar></full-calendar>
          </div>
        </div>
      </div>
    </div>
  </div>
